import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../../services/supplier_appCommonService";
import ItemService2 from "../../../../../services/customer_v2_appCommonService";

//Components
import Layout from "../../../../../Layout/Layout";
import Constants from "../../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addcustomerID,
  // getCustomerList,
  workflow,
} from "../../../../../redux/feature/customer_app/customerSlice";
// import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import ShowStatus from "../../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import {
  formatDate,
  getContactDetails,
} from "../../../../../common/Validations";
import { SearchField } from "../../../../../Components/formElements/SearchField";
import SuccessModal from "../../../../../Components/Modal/supplier_app/SuccessModal";
import CreateInviteSupplierModal from "../../../../../Components/Modal/supplier_app/CreateInviteSupplierModal";
import ConfirmSendInvitationModel from "../../../../../Components/Modal/supplier_app/ConfirmSendInvitationModel";
import ConfirmationLoader from "../../../../../Components/ConfirmationLoader";
import BroadcastModel from "../../../../../Components/Modal/supplier_app/BroadcastModel";
import CreateCustomerMasterModal from "../../../../../Components/Modal/customer_app/CreateCustomerMasterModal";
import { TableStatusField } from "../../../../../Components/formElements/TableStatusField";
import { formatDateTime } from "../../../../../common/Validations";
import LogisticsConstants from "../../../../../common/LogisticsConstants";
import {
  addVehicleNr,
  getVehicleList,
} from "../../../../../redux/feature/logistics_app/logisticsSlice";
import CustomerV2VhecileDeactivateModel from "../../../../customer_app/Customer_V2/Common/CustomerV2VhecileDeactivateModel";
import CommonFilterCustomerV2 from "../../../../customer_app/Customer_V2/Common/CommonFilterCustomerV2";

const VehicleList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Vehicle");

  let customerData = useSelector((state) => state?.logistics?.vehicle); // User Details from Store
  let customerTable = useSelector(
    (state) => state?.logistics?.vehicle?.pagination
  ); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /* setSendDataModal */] = useState("");
  const [modelTitle /* setModelTitle */] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [getAccountGroup, setAccountGroup] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false); // Loading state
  const [selectedRows, setSelectedRows] = useState([]);
  /* pop success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const successModalData = {
    title: "Success",
    successMsg: "",
  };
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const [getShowSendInvitationModal, setShowSendInvitationModal] =
    useState(false);
  const [getShowhideBroadcastModel, setShowhideBroadcastModel] =
    useState(false);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [getFilter, setFilter] = useState({});

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const hideSendInvitationModal = () => setShowSendInvitationModal(false);
  const hideBroadcastModel = () => setShowhideBroadcastModel(false);
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  const handleRowSelect = ({ selectedRows }) => {
    console.log(">>selectedRows", selectedRows);
    setSelectedRows(selectedRows);
  };
  const sendInvitation = async () => {
    if (selectedRows.length === 0) {
      // alert("Please select at least one row.")
      successModalData.title = "Error";
      successModalData.successMsg = "Please select at least one row.";
      setsucceModalData(successModalData);
      onSuccessmodel();
      return;
    }
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
      };
      // console.log("obj", obj);
      await ItemService.sendInvitation(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleBroadcast = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
        broadcastRemark: payload?.broadcastRemark,
      };
      // console.log("obj", obj);
      await ItemService.supplierBroadcast(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to Broadcast:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleDeactivateSupplier = async (payload) => {
    // console.log(">>payload",payload)
    try {
      setIsPageLoading(true); // Start loading
      const documentNumber = selectedRows.map((row) => row.documentNumber);
      // eslint-disable-next-line
      let obj = {
        querydocumentNumbers: documentNumber,
        remark: payload?.remark,
        status: "Deactivated", //or Activated
      };
      // console.log(">>obj", obj);
      await ItemService2.vehicleDeactivate(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
          let obj = {
            queryName: "getTruckMasterList",
            module: "",
            page: 1,
            per_page: 10,
          };
          dispatch(getVehicleList(obj));
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const inviteSupplier = async (formData) => {
    setIsPageLoading(true); // Start loading
    try {
      await ItemService.inviteSupplier(formData).then((item) => {
        if (item?.status === 200) {
          // console.log("item", item);
          successModalData.successMsg = item?.message;
          setShowSuccessModal(true);
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const detailedPage = (vehicleNr) => {
    dispatch(addVehicleNr(vehicleNr));
    navigate(LogisticsConstants.LOGISTICS_MASTER_VEHICLE_DETAILS);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on categoryItem  Data
  // eslint-disable-next-line no-unused-vars
  const showProjectDetailsModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(projectColModal);
    setModalTitle("Project Details");
    setItemLevelModalShow(true);
  };

  // OnClick on Certificate document Data
  const certificateDocumentShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(certificateDocumentColInfo);
    setModalTitle("Certificate document Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialSuuplierData = async () => {
    setData(customerData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getTruckMasterList",
      module: "",
      page: page,
      per_page: getNewPerPage,
            rowFilter: {
          $and: [getFilter],
        },
    };

    // dispatch(getCustomerList(obj));
    dispatch(getVehicleList(obj));

    setData(customerData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getTruckMasterList",
      module: "",
      page: page,
      per_page: newPerPage,
            rowFilter: {
          $and: [getFilter],
        },
    };
    setNewPerPage(newPerPage);
    // dispatch(getCustomerList(obj));
    dispatch(getVehicleList(obj));

    setData(customerData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getTruckMasterList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    // dispatch(getCustomerList(obj));
    dispatch(getVehicleList(obj));
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };

    fetchData();

    loadInitialSuuplierData(); // fetch page 1 of users
    dispatch(workflow({}));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData?.data]);

  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "getTruckMasterList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getVehicleList(obj));
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      name: "Vehicle ID",
      id:"truckNr",
      selector: (row) => row.truckNr || "--",
      sortable: true,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row.truckNr)}>
          {row.truckNr || "-"}{" "}
        </button>
      ),
      width: "130px",
    },
    {
      name: "Vehicle Nr",
      id:"vehicleRegistrationNr",
      cell: (row) => (
        <>
          <p className="mt-2 bg-table-status bg-table-new-status">
            {row?.vehicleRegistrationNr}{" "}
          </p>

          {/* <span className="m-0 p-0 pt-1 fw-bold">{row.registrationDate}</span> */}
        </>
      ),
      selector: (row) => row.vehicleRegistrationNr,
      // sortable: true,
      width: "150px",
    },
     {
      name: "Type",
      selector: (row) => row.type || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 text-success fw-bold">{row.type} </p>
          {/* <p className="m-0 p-0 fw-bold">{row.manufactureMake} </p> */}
        </div>
      ),
      // sortable: true,
      width: "120px",
    },
     {
      name: "Transporter",
      selector: (row) => row.transporter || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 text-success fw-bold">{row.transporter} </p>
          {/* <p className="m-0 p-0 fw-bold">{row.manufactureMake} </p> */}
        </div>
      ),
      // sortable: true,
      width: "120px",
    },
    {
      name: "Regn Date",
      id:"registrationDate",
      cell: (row) => (
        <>
          <p className="m-0 p-0 pt-1">{formatDate(row?.registrationDate)} </p>

          {/* <span className="m-0 p-0 pt-1 fw-bold">{row.registrationDate}</span> */}
        </>
      ),
      selector: (row) => row.registrationDate,
      // sortable: true,
      width: "150px",
    },

    {
      name: "Manufacture Make ",
      selector: (row) => row.manufactureMake || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.manufactureMake} </p>
          {/* <p className="m-0 p-0 fw-bold">{row.manufactureMake} </p> */}
        </div>
      ),
      // sortable: true,
      width: "150px",
    },
    {
      name: " Chessis Number",
      id:"chassisNr",
      selector: (row) => row.chassisNr || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 text-primary fw-bold">{row.chassisNr} </p>
          {/* <p className="m-0 p-0 ">{row.engineNr} </p> */}
        </div>
      ),
      // sortable: true,
      width: "180px",
    },
    {
      name: " Engine Number",
      id:"engineNr",
      selector: (row) => row.engineNr || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 text-primary fw-bold ">{row.engineNr} </p>
          {/* <p className="m-0 p-0 ">{row.engineNr} </p> */}
        </div>
      ),
      // sortable: true,
      width: "250px",
    },
    {
      name: "No of Tyres",
      selector: (row) => row.noOfTyres,
      // sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.noOfTyres} />
        </>
      ),
      width: "140px",
    },

    {
      name: "Status",
      cell: (row) => (
        <TableStatusField status={row.activeInactive ? "Active" : "Inactive"} />
      ),
      width: "130px",
    },

    {
      name: "Documents",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            // onClick={() => certificateDocumentShowModal(row?.certifications||"")}
            onClick={() => {
              if (
                Array.isArray(row?.certifications) &&
                row?.certifications.length > 0
              ) {
                certificateDocumentShowModal(row?.certifications);
              }
            }}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {row?.certifications?.length > 0
              ? row?.certifications?.length
              : "0"}
          </span>
        </>
      ),
      width: "130px",
    },

    {
      name: "Contact Person",

      cell: (row) => (
        <>
          <span>{getContactDetails(row)?.contactName}</span>
        </>
      ),
      // selector: (row) => row.contactfirstName || "--",
      // sortable: true,
      width: "150px",
    },
    {
      name: "Contact Nr/Email",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">
            {getContactDetails(row)?.contactNumber}
          </p>
          <p className="p-0 m-0 fw-medium">
            {getContactDetails(row)?.contactEmail}
          </p>
        </div>
      ),
      // selector: (row) => row.contactNumber,
      sortable: true,
      width: "180px",
    },
    // {
    //   name: "Contact Number",
    //   cell: (row) => (
    //     <>
    //       <span>{getContactDetails(row)?.contactNumber}</span>
    //     </>
    //   ),
    //   // selector: (row) => row.contactNumber,
    //   // sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Contact Email",
    //   cell: (row) => (
    //     <>
    //       <span>{getContactDetails(row)?.contactEmail}</span>
    //     </>
    //   ),
    //   // selector: (row) => row.email,
    //   // sortable: true,
    //   width: "220px",
    // },

    {
      name: "Created Date",
      id:"createdAt",
      selector: (row) => formatDateTime(row?.createdAt),
      // sortable: true,
      width: "160px",
    },
  ];

  const projectColModal = [
    {
      name: "Project Code",
      cell: (row) => <span>{row.projectCode} </span>,
      width: "180px",
    },
    {
      name: "Project Name",
      cell: (row) => <span>{row.projectName} </span>,
      width: "180px",
    },
    {
      name: "Project Location",
      cell: (row) => (
        <span>
          {row.getLocations?.length > 0
            ? row.getLocations[0]?.projectLocation
            : ""}
        </span>
      ),
      width: "180px",
    },
    {
      name: "Project State",
      cell: (row) => <span>{row.projectState} </span>,
      width: "180px",
    },
    {
      name: "Project Country",
      cell: (row) => <span>{row.projectCountry} </span>,
      width: "180px",
    },
  ];

  const certificateDocumentColInfo = [
    {
      name: "Certificate Type",
      cell: (row) => <span>{row.documentType} </span>,
      width: "180px",
    },
    {
      name: "Certificate Number",
      cell: (row) => <span>{row.documentNumber} </span>,
      width: "180px",
    },
    {
      name: "Issuing Date",
      cell: (row) => <span>{formatDate(row.issueDate)} </span>,
      width: "180px",
    },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const handleCustomerRegister = () => {
    navigate(LogisticsConstants.LOGISTICS_MASTER_VEHICLE_CREATE);
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getTruckMasterList",
   
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getVehicleList(obj));
  };
  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <ConfirmationLoader isPageLoading={isPageLoading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Vehicle List</h2>
                <p className="subText">Vehicle Directory and Overview </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
               <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
              <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">VL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Vehicle List</span>
                      <span className="subHeaderTitle">
                        View of Vehicle and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="me-2">
                        <button
                          className="btnTable"
                          onClick={handleCustomerRegister}
                        >
                          <i className="bi bi-person-plus"></i> Add Vehicle
                        </button>
                      </Col>

                      {/* {config?.deactivateListBtn && (
                        <Col xs={4} md={2} lg={2} className="btnSpaceInMobile">
                          <button
                            className="btnTable"
                            onClick={() => setShowSupplierDeactivateModel(true)}
                          >
                            Deactivate List
                          </button>
                        </Col>
                      )} */}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i className="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={customerData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateCustomerMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdownData={getAccountGroup}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
      <CreateInviteSupplierModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onSubmit={inviteSupplier}
      />
      <ConfirmSendInvitationModel
        show={getShowSendInvitationModal}
        onHide={hideSendInvitationModal}
        onSubmit={sendInvitation}
        selectedRows={selectedRows}
      />
      <BroadcastModel
        show={getShowhideBroadcastModel}
        onHide={hideBroadcastModel}
        onSubmit={handleBroadcast}
        selectedRows={selectedRows}
      />
      <CustomerV2VhecileDeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />
    </main>
  );
};

export default VehicleList;
